
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/raise-a-claim",
      function () {
        return require("private-next-pages/support/raise-a-claim/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/raise-a-claim"])
      });
    }
  